import Action from "./class.Action";

export default class SetVariable extends Action {
	/**
	 * Public Constructor
	 * @param {string[]} options
	 * @returns
	 */
	constructor(options) {
		super(options);

		// Make sure the values are set
		if (options.model.varName && options.model.varVal) {
			const varName = options.model.varName;
			const varVal = options.model.varVal;

			// Update the value in the debugger
			this.mainController.transporterVariables.setValue(varName, varVal);
		}

		// For debug mode we display a bubble, this won't show up in a real session
		if (options.attributes.playthrough_id === null) {
			this.renderDebugBubble(options);
		}

		return this.onAdvance(this.$anchor);
	}

	/**
	 * Display bubble in debug mode
	 * @param {string} varName
	 * @param {string} varVal
	 */
	renderDebugBubble(options) {
		let content = "";

		if (options.model.varName && options.model.varVal) {
			const varName = options.model.varName;
			const varVal = options.model.varVal;
			content = "<em>Set Var:</em> " + varName + " = " + varVal;
		} else {
			content = "<em>ERROR:</em> Missing values";
		}

		const bubbleView = this.layoutView.placeBubble(
			this.$anchor,
			this.method,
			"center"
		);
		bubbleView.setContent(content);
	}
}
